import Vue from "vue/dist/vue.esm.browser.js"
import ItemConfigure from "./ItemConfigure.vue"

// Make Frappe i18n function `__` available to use from within Vue components
Vue.prototype.__ = window.__
// Make Global `frappe` object available to use from within Vue components
Vue.prototype.frappe = window.frappe

new Vue({
  el: "#item-variants",
  render: h => h(ItemConfigure)
})
